import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useGetCbsSignature = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("POST");

  const getToken = async (body: any, version: string) => await makeApiRequest(`${apiBase}/api/cyber-source/signatures/${version}`, body);

  return [getToken];
};

export default useGetCbsSignature;
